module.exports = __webpack_public_path__ + "img/catechete.38425e7b.jpg";